<ng-template #content let-modal>
	<div class="modal-header mx-3 px-0 pb-2">
		<h2 class="modal-title fw-bolder text-primary">NEED HELP ON THIS PAGE?</h2>		
	</div>
	
  <div class="modal-body p-3" *ngIf="!serviceCalled;else loadHelp">
    <div class="text-center">
      <div class="mydeq-busy">
        <div class="mydeq-busy-spinner"></div>
      </div>
    </div>
  </div>

  <ng-template #loadHelp>
    <div class="modal-body pt-3 pb-5 px-0">
      <div id="video" class="card" *ngIf="videos && videos.length > 0">
        <div class="card-body pb-0 pt-2">
          <div class="mx-3">
            <div class="embed-responsive" *ngFor="let video of videos" style="height:315px">
              <h4 class="card-title text-primary">{{video.title}}</h4>
              <iframe height="315px" class="embed-responsive-item" [attr.src]="video.url | safeUrl" frameborder="0"
                allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
      <div id="faq" class="card pt-2" *ngIf="faqs && faqs.length > 0">
        <div class="card-body pb-0 pt-2">
          <h3 class="card-title text-primary">FAQs:</h3>
          <div class="mx-2">
            <ngb-accordion #acc="ngbAccordion" (panelChange)="beforeChange($event)">
              <ngb-panel *ngFor="let faq of faqs, let i=index;" id="ngb-panel-{{i + 1}}" type="info">
                <ng-template ngbPanelTitle>
                  <div class="h5">
                    <i id="square-ngb-panel-{{i + 1}}" class="fa fa-plus-square-o pl-2"></i> {{faq.title}}
                  </div>
                </ng-template>
                <ng-template ngbPanelContent class="bg-info">
                  <span class="h6" [innerHTML]="faq.description"></span>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
      </div>
      <div id="contactUS" class="card" *ngIf="contactDetails && contactDetails.length > 0">
        <div class="card-body py-0">
          <h3 *ngIf="(faqs && faqs.length > 0) || (videos && videos.length > 0)"
            class="card-title text-primary my-2">Contact Us:</h3>
          <div class="card-text h5 pt-3 pb-2 clearfix" *ngFor="let contact of contactDetails; let last = last"
            [ngClass]="{'mx-3': (faqs && faqs.length > 0) || (videos && videos.length > 0), 'border-bottom': !last}">
            <div class="float-start fw-normal text-capitalize">{{contact.division}}</div>
            <div class="float-end text-primary">{{contact.phone | phone}}</div>            
          </div>

        </div>
      </div>
      <div id="resource" class="card" *ngIf="resourceDetails && resourceDetails.length > 0">
        <div class="card-body">
          <h3 class="card-title text-primary">Resources:</h3>
          <p class="card-text h6 mb-1" *ngFor="let resource of resourceDetails">
            <strong>{{resource.title}}</strong>
            <span class="text-primary">{{resource.description}}</span>
          </p>
        </div>
      </div>
    </div>
  </ng-template>
	
  <div class="modal-footer border-0 pe-0 pb-0">
    <button type="button" class="btn btn-primary bottom-btn float-end me-0 mb-0" (click)="modalService.dismissAll('')">EXIT HELP
      <span class="arrow right">
        <i class="fa fa-chevron-right"></i>
      </span>
    </button>
  </div>
</ng-template>

<button class="btn btn-lg btn-outline-primary" id="need-help-btn" hidden (click)="open(content)">Launch demo modal</button>
